import { AdminPageLayout } from "@/layouts/AdminPageLayout";
import React from "react";
import { OperationItem, OperationsList } from "../Access/OperationsList";

const items: OperationItem[] = [
  {
    title: "Student Progress Report",
    description:
      "Track student performance, completion rates, and learning outcomes across all courses.",
    image:
      "https://images.unsplash.com/photo-1460925895917-afdab827c52f?auto=format&fit=crop&w=800",
    route: "/admin/reports/student-progress",
  },
  {
    title: "Course Completion Report",
    description:
      "View detailed statistics on course completion rates, average completion time, and success metrics.",
    image:
      "https://images.unsplash.com/photo-1434030216411-0b793f4b4173?auto=format&fit=crop&w=800",
    route: "/admin/reports/course-completion",
  },
  {
    title: "Financial Report",
    description:
      "Access comprehensive financial data including revenue, enrollments, and payment analytics.",
    image:
      "https://images.unsplash.com/photo-1554224155-8d04cb21cd6c?auto=format&fit=crop&w=800",
    route: "/admin/reports/financial",
  },
  {
    title: "Acessos por dia",
    description:
      "Visualize login events per day for the selected date range.",
    image:
      "https://images.unsplash.com/photo-1551288049-bebda4e38f71?auto=format&fit=crop&w=800",
    route: "/admin/reports/accesses-by-day",
  },
  {
    title: "Cadastros por dia",
    description:
      "Visualize registration events per day for the selected date range.",
    image:
      "https://images.unsplash.com/photo-1551288049-bebda4e38f71?auto=format&fit=crop&w=800",
    route: "/admin/reports/registrations-by-day",
  },
];

const AdminReportsPage: React.FC = () => {
  return (
    <AdminPageLayout title="Reports">
      <OperationsList items={items} />
    </AdminPageLayout>
  );
};

export default AdminReportsPage;
